import API from '../../../../../global/api';

export const getJudgementData = () => {
    return (dispatch) => {
      API.get(`/form_190_notic_entry_judgment/get-call`, {
        headers: {
          /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
        },
      }).then((res) => {
        let data = [];
        data = res.data;
        dispatch(successGetJudgementData(data));
      });
    };
  };
  


export const requestGetJudgementData = (data) =>{
    return {
        type: "REQUEST_GET_JUDGEMENT_DATA",
    }
}

export const successGetJudgementData = (data) =>{
    return {
        type: "SUCCESS_GET_JUDGEMENT_DATA",
        payload: data,
    }
}

export const errorGetJudgementData = (data)=>{
    return {
        type: "ERROR_GET_JUDGEMENT_DATA",
        payload: data,
    }
}

export const postJudgementData=(data)=>{
    return(dispatch)=>{
        API.post(`/form_190_notic_entry_judgment/form-190-add`, data).then((res)=>{
            dispatch(successPostJudgementData(data));
        })  
    }    
}

export const requestPostJudgementData = (data) =>{
    return {
        type: "REQUEST_POST_JUDGEMENT_DATA",       
    }
}
export const successPostJudgementData=(data)=>{
    return{
        type:"SUCCESS_POST_JUDGEMENT_DATA",
        payload: data,
    }
}
export const errorPostJudgementData = (data)=>{
    return{
        type: "ERROR_POST_JUDGEMENT_DATA",
        payload: data,
    }
}